import { SearchTable } from './SearchTable';
import { useCovaloColumns } from './columns/CovaloColumns';
import {
  IngredientIdentifier,
  SearchCategoryType,
  SearchDocument,
  SearchCategories
} from 'types/Search';
import { MRT_Row } from 'material-react-table';
import { SearchViewPropsExtended } from './types';
import { SegmentTag } from 'types/global';
import { useSearchTableColumnManagement } from './hooks/useSearchTableColumnManagement';
import { ProductType } from 'types/Products';
import { useFlags } from 'launchdarkly-react-client-sdk';
type SearchTableProps<T extends object> = {
  setShowRegisterModal: (a: boolean) => void;
} & SearchViewPropsExtended<T>;

export const CovaloTable: React.FC<
  SearchTableProps<SearchDocument>
> = props => {
  const eventKey = props.searchResults?.search?.event;
  const { searchTableColumnsConfiguration } = useFlags();

  const columns = useCovaloColumns(
    props.target,
    props.searchResults.search?.segment ?? SegmentTag.PERSONALCARE,
    eventKey
  );

  const generateProductPageLink = (row: MRT_Row<SearchDocument>) => {
    return eventKey
      ? `/events/${eventKey}/product/${row.original.old_key}`
      : `/${props.searchResults.search?.target.toLowerCase()}/permalink/${
          row.original.old_key
        }`;
  };

  const defaultColumnConfigurations = (type: ProductType) => {
    switch (type) {
      case ProductType.INGREDIENTS:
        return [
          { id: IngredientIdentifier.INCI },
          { id: SearchCategories.APPLICATIONS },
          { id: 'certifications' }
        ];
      case ProductType.FORMULATIONS:
        return [
          { id: SearchCategories.APPLICATIONS },
          { id: SearchCategoryType.PERFORMANCE }
        ];
      case ProductType.SERVICES:
        return [
          { id: SearchCategories.APPLICATIONS },
          { id: SearchCategories.SPECIALIZATION }
        ];
    }
  };

  const initialColumnState = [
    { id: 'name' },
    { id: 'company.name' },
    ...defaultColumnConfigurations(props.target as ProductType)
  ];

  const { columnOrder, setColumnOrder, columnVisibility, setColumnVisibility } =
    useSearchTableColumnManagement(
      `covalo_marketplace_${props.target}`,
      initialColumnState,
      columns
    );
  return (
    <SearchTable<SearchDocument>
      {...props}
      getRowId={row => row.id}
      columns={columns}
      enableMarketingBanner
      generateItemPageLink={generateProductPageLink}
      columnManagement={
        searchTableColumnsConfiguration
          ? {
              columnOrder,
              setColumnOrder,
              columnVisibility,
              setColumnVisibility
            }
          : undefined
      }
    />
  );
};
